import { render, staticRenderFns } from "./NewChatMessageMedia.vue?vue&type=template&id=c6c76daa"
import script from "./NewChatMessageMedia.vue?vue&type=script&lang=js"
export * from "./NewChatMessageMedia.vue?vue&type=script&lang=js"
import style0 from "./NewChatMessageMedia.vue?vue&type=style&index=0&id=c6c76daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports